"use client";

import { LogOut } from "lucide-react";
import { useRouter } from "next/navigation";
import type { FC } from "react";

import { DropdownMenuItem } from "~/components/dropdown-menu";
import { signOut } from "~/lib/auth.client";

export const LogoutItem: FC = () => {
	const router = useRouter();

	return (
		<DropdownMenuItem onClick={async () => {
			await signOut();

			router.refresh();
			router.push("/login");
		}}
		>
			<LogOut />
			Log out
		</DropdownMenuItem>
	);
};
